import { View, ViewProps } from '@amzn/stencil-react-components/layout';
import React from 'react'
import { useTranslation } from "react-i18next";
import TranslationKeys from 'src/constants/translation-keys';
import { useStencilContext, ThemeMode } from '@amzn/stencil-react-components/context';

type LogoProps = {
    src: string;
    darkSrc?: string;
} & ViewProps;

const Logo = (props: LogoProps) => {
    const { t } = useTranslation();
    const { themeMode } = useStencilContext();
    const isDarkMode = themeMode === ThemeMode.Dark;
    const logoSrc = isDarkMode && props.darkSrc ? props.darkSrc : props.src;
    return (
        <View className={`logo ${props.className}`}>
            <img data-testid='atoz-logo' src={logoSrc} alt={t(TranslationKeys.UI.IMAGE.ATOZ_LOGO_ALT)} />
        </View>
    );
}

export default Logo;
